var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "components-panel" }, [
    !_vm.isSingleMode
      ? _c(
          "div",
          {
            staticClass: "components-panel-header",
            on: { click: _vm.toggleDropdown },
          },
          [
            _c("span", [_vm._v("添加图表")]),
            _vm._v(" "),
            _c("i", {
              staticClass: "el-icon-arrow-down",
              class: { "is-expanded": _vm.isDropdownOpen },
            }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isDropdownOpen
      ? _c("div", { staticClass: "dropdown-overlay" }, [
          _c(
            "div",
            { staticClass: "dropdown-container" },
            [
              _c("c-tabs", {
                staticStyle: { "background-color": "#fff" },
                attrs: { tabList: _vm.tabList },
                on: {
                  change: function ($event) {
                    return _vm.handleTabChange(_vm.activeTab, true)
                  },
                },
                model: {
                  value: _vm.activeTab,
                  callback: function ($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "components-widgets" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "jzliu-cli-bi-engine-components-panel-query",
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            "popper-append-to-body": false,
                            size: "mini",
                            placeholder: "请选择",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleTabChange(_vm.activeTab)
                            },
                          },
                          model: {
                            value: _vm.queryList.classify,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryList, "classify", $$v)
                            },
                            expression: "queryList.classify",
                          },
                        },
                        _vm._l(_vm.classifyListView, function (i) {
                          return _c("el-option", {
                            key: i.value,
                            attrs: { label: i.label, value: i.value },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: { size: "mini", placeholder: "请输入指标名称" },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleTabChange(_vm.activeTab)
                          },
                          change: function ($event) {
                            return _vm.handleTabChange(_vm.activeTab)
                          },
                        },
                        model: {
                          value: _vm.queryList.search,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryList, "search", $$v)
                          },
                          expression: "queryList.search",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-popover",
                        {
                          ref: "filterPopover",
                          attrs: {
                            placement: "bottom-end",
                            width: "400",
                            trigger: "click",
                            "popper-class": "jzliu-bi-filter-popover",
                          },
                          on: { show: _vm.openFilterPopover },
                          model: {
                            value: _vm.filterPopoverVisible,
                            callback: function ($$v) {
                              _vm.filterPopoverVisible = $$v
                            },
                            expression: "filterPopoverVisible",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "jzliu-bi-filter-popover-content" },
                            _vm._l(_vm.filterCategories, function (category) {
                              return _c(
                                "div",
                                {
                                  key: category.key,
                                  staticClass: "jzliu-bi-filter-category",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "jzliu-bi-filter-category-label",
                                    },
                                    [_vm._v(_vm._s(category.label))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "jzliu-bi-filter-options" },
                                    _vm._l(category.options, function (option) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: option.value,
                                          staticClass:
                                            "jzliu-bi-filter-checkbox",
                                          attrs: {
                                            value: _vm.isFilterOptionActive(
                                              category.key,
                                              option.value
                                            ),
                                            indeterminate:
                                              option.value === "all" &&
                                              _vm.isFilterIndeterminate(
                                                category.key
                                              ),
                                          },
                                          on: {
                                            change: function (checked) {
                                              return _vm.handleCheckboxChange(
                                                category.key,
                                                option.value,
                                                checked,
                                                category
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(option.label) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "jzliu-bi-filter-popover-footer" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.resetFilters },
                                },
                                [_vm._v("重置")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.applyFilters },
                                },
                                [_vm._v("确定")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-badge",
                            {
                              attrs: {
                                slot: "reference",
                                value: _vm.activeFilterCount,
                                hidden: _vm.activeFilterCount === 0,
                                max: 99,
                              },
                              slot: "reference",
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "jzliu-cli-bi-engine-components-panel-query-img",
                                class: { "is-active": _vm.hasActiveFilters },
                                attrs: {
                                  width: "16",
                                  height: "16",
                                  src: require("@/assets/img/filter.png"),
                                  alt: "filter",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.localWidgets.length
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "align-items": "center",
                            "justify-content": "center",
                            height: "100%",
                            "margin-top": "100px",
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "empty-img",
                            attrs: {
                              width: "50%",
                              src: require("@/assets/img/empty.png"),
                              alt: "empty",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#999",
                              },
                            },
                            [_vm._v("暂无数据")]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.localWidgets, function (i) {
                    return _c(
                      "div",
                      {
                        key: _vm.activeTab + "_" + i._wid,
                        staticStyle: {
                          "background-color": "#fff",
                          padding: "12px 16px",
                          "margin-bottom": "12px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "components-item-warp",
                            attrs: { draggable: "true", unselectable: "on" },
                            on: {
                              click: function ($event) {
                                return _vm.clickToAdd(i)
                              },
                              drag: function ($event) {
                                return _vm.drag(i)
                              },
                              dragend: function ($event) {
                                return _vm.dragend(i)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "indicator-title",
                                    attrs: { title: i.dataSetName },
                                  },
                                  [_vm._v(_vm._s(i.dataSetName))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.getAuditStatus(i),
                                      placement: "top",
                                      effect: "dark",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "jzliu-cli-bi-engine-components-panel-status",
                                        style: {
                                          backgroundColor:
                                            _vm.getAuditBgColor(i),
                                          color: _vm.getAuditColor(i),
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.getAuditStatus(i)))]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", {
                              class: [
                                "jzliu-cli-bi-engine-components-panel-query-img-icon",
                                _vm.bgImgClass(i),
                              ],
                            }),
                          ]
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }